/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-explicit-any */
import DeleteIcon from "@mui/icons-material/Delete";
import { Button, Checkbox, Grid, Paper, TextField } from "@mui/material";
import { useContext, useState } from "react";
import CoefficientComponent from "./CoefficientComponent";
import AddIcon from "@mui/icons-material/Add";
import Question from "./Question";
import { Vocabulary } from "../../Utils/Vocabulary";
import style from "./Questionnaire.module.scss";
import AddImages from "./AddImages";
import { AnswerState, QuestionsContext } from "../../Context/questionsContext";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

type AnswerRowsProps = {
  answerNumber: number;
  answerType: string;
  answer: AnswerState;
  answers: Array<AnswerState>;
  saveQuestionnaires: (e: any) => void;
};
export default function AnswerRows(props: AnswerRowsProps) {
  const { answerNumber, answer, answerType, answers, saveQuestionnaires } =
    props;
  const questionsContext = useContext(QuestionsContext);
  const [openAddImagesModal, setOpenAddImagesModal] = useState(false);

  /**
   *
   * @param e
   * @param index
   */
  function handleChangeAnswer() {
    const newQuestions = questionsContext.questions.slice();
    questionsContext.setQuestions(newQuestions);
  }

  /**
   *
   * @param answerNumber
   * @param questionNumber
   */
  function deleteAnswer() {
    answers.splice(answerNumber, 1);
    handleChangeAnswer();
  }

  /**
   *
   * @param answerNumber
   * @param questionNumber
   */
  function addNewQuestionToAnswer() {
    if (answer.questions) {
      answer.questions.push({
        question: "",
        answerType: "singleChoice",
        minValue: 0,
        maxValue: 0,
        images: [],
        files: [],
        answers: [
          {
            option: "",
            minValue: 0,
            maxValue: 0,
            coefficientType: "LEI",
            coefficientValue: 0,
            hardStop: false,
            questions: [],
            images: [],
            files: [],
            helperText: null,
          },
        ],
        openCollapse: true,
      });
    } else {
      answer.questions = [
        {
          question: "",
          answerType: "singleChoice",
          minValue: 0,
          maxValue: 0,
          images: [],
          files: [],
          answers: [
            {
              option: "",
              minValue: 0,
              maxValue: 0,
              coefficientType: "LEI",
              coefficientValue: 0,
              hardStop: false,
              questions: [],
              images: [],
              files: [],
              helperText: null,
            },
          ],
          openCollapse: true,
        },
      ];
    }
    handleChangeAnswer();
  }

  /**
   *
   * @param e
   * @param answerNumber
   */
  function handleChangeCoefficient(e: any) {
    const newAnswer = answer as any;
    newAnswer[e.target.name] = e.target.value;
    handleChangeAnswer();
  }

  /**
   *
   * @param e
   * @param answerNumber
   */
  function handleChangeHardStop(e: any) {
    answer.hardStop = e.target.checked;
    handleChangeAnswer();
  }

  /**
   *
   */
  function handleCloseOpenAddImagesModal() {
    setOpenAddImagesModal(false);
  }

  /**
   * Moves a question up or down in the array.
   *
   */
  function moveAnswer(index: number, position: number) {
    if (index === 0 && position < 0) return;
    if (index === answers.length - 1 && position > 0) return;

    const [removedQuestion] = answers.splice(index, 1);

    answers.splice(index + position, 0, removedQuestion);

    handleChangeAnswer();
  }

  return (
    <>
      <Grid
        container
        spacing={2}
        style={{ padding: 15 }}
        key={`answers_${answerNumber}`}
      >
        <Grid item lg={1}>
          <KeyboardArrowUpIcon
            className={style.btnIcon}
            onClick={() => moveAnswer(answerNumber, -1)}
            style={{
              cursor: answerNumber === 0 ? "not-allowed" : "pointer",
            }}
          />
          <KeyboardArrowDownIcon
            className={style.btnIcon}
            onClick={() => moveAnswer(answerNumber, 1)}
            style={{
              cursor:
                answerNumber === answers.length - 1 ? "not-allowed" : "pointer",
            }}
          />
        </Grid>
        <Grid item lg={2}>
          {answerType !== "slider" ? (
            <TextField
              type="text"
              name="option"
              label={Vocabulary.option}
              style={{ margin: "10px 0px" }}
              value={answer.option}
              onChange={(e) => {
                answer.option = e.target.value;
                handleChangeAnswer();
              }}
              fullWidth
              size="small"
            />
          ) : (
            <>
              <TextField
                type="text"
                name="maxValue"
                label={Vocabulary.maxValue}
                style={{ margin: "10px 0px" }}
                value={answer.maxValue}
                onChange={(e) => {
                  answer.maxValue = +e.target.value || 0;
                  handleChangeAnswer();
                }}
                size="small"
              />
              <TextField
                type="text"
                name="minValue"
                label={Vocabulary.minValue}
                style={{ margin: "10px 0px" }}
                value={answer.minValue}
                onChange={(e) => {
                  answer.minValue = +e.target.value || 0;
                  handleChangeAnswer();
                }}
                size="small"
              />
            </>
          )}
        </Grid>
        <Grid item lg={2}>
          <TextField
            type="text"
            name="helperText"
            label={Vocabulary.description}
            style={{ margin: "10px 0px" }}
            value={answer.helperText}
            onChange={(e) => {
              answer.helperText = e.target.value;
              handleChangeAnswer();
            }}
            fullWidth
            size="small"
          />
        </Grid>
        <Grid item lg={2}>
          <CoefficientComponent
            answer={answer}
            answerNumber={answerNumber}
            handleChangeCoefficient={handleChangeCoefficient}
          />
        </Grid>
        <Grid item lg={2} className={style.answerGrid}>
          <Checkbox
            checked={answer.hardStop}
            onChange={(e) => handleChangeHardStop(e)}
            style={{ marginTop: 10 }}
          />
        </Grid>
        <Grid item lg={2} className={style.answerGrid}>
          <Button
            size="large"
            style={{
              verticalAlign: "center",
            }}
            onClick={() => setOpenAddImagesModal(true)}
          >
            {Vocabulary.addImages} ({answer.images ? answer.images.length : 0})
          </Button>
          <br />
          <Button onClick={() => addNewQuestionToAnswer()}>
            <AddIcon style={{ marginRight: 7 }} />
            {Vocabulary.newQuestion}
          </Button>
        </Grid>
        <Grid item lg={1} className={style.answerGrid}>
          <Button
            onClick={() => deleteAnswer()}
            disabled={answers.length === 1}
          >
            <DeleteIcon className={style.deleteIcon} />
          </Button>
        </Grid>
        {answer.questions && answer.questions.length !== 0 ? (
          <Grid item lg={12} className={style.questionForAnswers}>
            {answer.questions.map((question: any, index: number) => (
              <Paper
                key={`answers.questions_${index}`}
                className={style.questionPaper}
              >
                <Question
                  questionNumber={index}
                  questions={answer.questions}
                  answerText={answer.option}
                  saveQuestionnaires={saveQuestionnaires}
                />
              </Paper>
            ))}
          </Grid>
        ) : (
          ""
        )}
      </Grid>
      {openAddImagesModal ? (
        <AddImages
          openModal={openAddImagesModal}
          handleCloseModal={handleCloseOpenAddImagesModal}
          state={answer}
          saveQuestionnaires={saveQuestionnaires}
        />
      ) : null}
    </>
  );
}
